// eslint-disable-next-line import/no-anonymous-default-export
export default {
  orange: "#BED701",
  black: "#383838",
  backgroundLinearGrey: "#e7e7e7",
};
